import React from 'react'
import { Link } from 'react-router-dom'
import { Table, Icon } from 'semantic-ui-react'
import { Pagination, SortIcon } from '../components'
import { assignableRoles } from '../../common/config'

const { Header, Body, Row, Cell, HeaderCell, Footer } = Table

const sortIcons = {
  ascending: <SortIcon ascending />,
  descending: <SortIcon descending />,
  sort: <SortIcon />,
}

const getUserActive = (result) => {
  if (!result.archivedAt) {
    return <Icon name="user" color="green" size="large" />
  } else {
	return <Icon name="remove user" color="red" size="large" />
  }
}

const UsersTable = ({
  users, meta, list, waitingForDownload, getCSV, csv, clearDownload,
}) => {
  const paging = list.$paging(meta.count)
  return (
    <Table className="results">
      <Header>
        <Row>
		  <HeaderCell />
          <HeaderCell>{list.$heading('lastNameSort', 'Přijmení', sortIcons)}</HeaderCell>
          <HeaderCell>{list.$heading('firstNameSort', 'Jméno', sortIcons)}</HeaderCell>
          <HeaderCell>{list.$heading('email', 'Email', sortIcons)}</HeaderCell>
          <HeaderCell>{list.$heading('role', 'Role', sortIcons)}</HeaderCell>
          <HeaderCell />
        </Row>
      </Header>
      <Body>
        {users.map((u) => (
          <Row key={u._id}>
			<Cell className="cell-with-icon">{getUserActive(u)}</Cell>
            <Cell>{u.lastName}</Cell>
            <Cell>{u.firstName}</Cell>
            <Cell>{u.email}</Cell>
            <Cell>{assignableRoles[u.role]}</Cell>
            <Cell><Link to={`/users/${u._id}`}><i className="daicon daicon-Edit" /> Upravit</Link></Cell>
          </Row>
        ))}
      </Body>
      <Footer>
        <Row>
          <Cell colSpan={3}>
            {`
              Zobrazeno
              ${Math.min(((meta.currentPage - 1) * 100) + 1, meta.count)}
              -
              ${Math.min((meta.currentPage * 100) + 1, meta.count)} z ${meta.count}
            `}
            {(getCSV || csv) && <span>-&nbsp;</span>}
            {getCSV && !csv &&
              <span className="downloadCSV">
                {waitingForDownload
                  ? <Icon loading name="spinner" />
                  : <a onClick={getCSV}>Stáhnout CSV</a>
                }
              </span>
            }
            {csv &&
              <a href={csv} rel="noopener noreferrer" target="_blank" onClick={clearDownload}>
                CSV připraveno, klikněte pro stažení
              </a>
            }
          </Cell>
          <Cell colSpan={2}><Pagination paging={paging} /></Cell>
        </Row>
      </Footer>
    </Table>
  )
}

UsersTable.defaultProps = {
  getCSV: null,
  waitingForDownload: false,
  csv: '',
}

UsersTable.propTypes = {
  users: React.PropTypes.object.isRequired,
  meta: React.PropTypes.object.isRequired,
  list: React.PropTypes.object.isRequired,
  getCSV: React.PropTypes.any,
  waitingForDownload: React.PropTypes.bool,
  clearDownload: React.PropTypes.func.isRequired,
  csv: React.PropTypes.string,
}

export default UsersTable



// WEBPACK FOOTER //
// ./src/browser/tables/Users.js